import * as React from 'react'
import { cva, type VariantProps } from 'class-variance-authority'
import { cn } from '@/lib/utils'

const emptyStateVariants = cva(
  'flex flex-col items-center text-center',
  {
    variants: {
      variant: {
        default: 'py-16 px-6',
        minimal: 'py-8 px-4',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  }
)

export interface EmptyStateProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof emptyStateVariants> {
  icon?: React.ReactNode
  title: string
  description?: string
  action?: React.ReactNode
}

const EmptyState = React.forwardRef<HTMLDivElement, EmptyStateProps>(
  ({ className, variant, icon, title, description, action, ...props }, ref) => {
    return (
      <div
        ref={ref}
        className={cn(emptyStateVariants({ variant }), className)}
        {...props}
      >
        {icon && (
          <div className="p-4 rounded-full bg-[var(--color-surface-hover)] mb-4">
            {icon}
          </div>
        )}
        <h3 className={cn(
          'font-semibold text-foreground',
          variant === 'minimal' ? 'text-base' : 'text-lg'
        )}>
          {title}
        </h3>
        {description && (
          <p className={cn(
            'text-muted-foreground mt-2 max-w-md',
            variant === 'minimal' ? 'text-xs' : 'text-sm'
          )}>
            {description}
          </p>
        )}
        {action && (
          <div className="mt-6">
            {action}
          </div>
        )}
      </div>
    )
  }
)
EmptyState.displayName = 'EmptyState'

export { EmptyState, emptyStateVariants }
